<script setup>
import { Container, Pagination } from '@codinglabsau/ui'
import MembersCard from '@/Components/Users/MembersCard.vue'
import HeadMetaTags from '@/Components/HeadMetaTags.vue'
import PageHeader from '@/Components/PageHeader.vue'

defineProps({
  supporters: Object,
})
</script>

<template>
  <HeadMetaTags
    title="Supporters Club"
    description="Meet the supporters of Convict Records! These dedicated members help preserve and expand Australia's convict history by contributing to the platform’s ongoing success."
    :canonical="route('members.supporters.index')"
    :url="route('members.supporters.index')"
  />

  <Container>
    <PageHeader title="Supporter" />
    <div class="flex w-full flex-col gap-4 bg-white p-4 sm:grid sm:grid-cols-2 lg:grid-cols-3">
      <MembersCard v-for="supporter in supporters.data" :key="supporter.id" :user="supporter" />
    </div>
    <Pagination :collection="supporters" />
  </Container>
</template>
